import { useEffect } from "react";
import { useForm } from "react-hook-form";
import ReactModal from "react-modal";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { IScheduleFilters, StatusType } from "../common/interfaces/ScheduleFilters";
import ButtonSecondary from "../components/buttons/ButtonSecondary";
import RadioButtonField from "../components/fields/RadioButtonField";
import "./customModal.css";

const ModalContainer = styled.div`
	background-color: #ffffff;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border: 2px solid #e9ecef;
	border-radius: 8px;
	box-shadow: 0px 4px 4px 1px #0000000a;
	width: 80%;
	max-width: 275px;
	display: flex;
	flex-direction: column;
`;

const ModalHeader = styled.span`
	font-family: Livvic;
	font-size: 18px;
	font-weight: 600;
	line-height: 30px;
	letter-spacing: 0.005em;
	text-align: center;
	padding: 12px 24px;
`;

const ModalContent = styled.div`
	padding: 12px 36px;
	display: flex;
	flex-direction: column;
	height: 100%;
`;

const ModalFilterGroup = styled.div`
	span {
		font-family: Livvic;
		font-size: 14px;
		font-weight: 600;
		line-height: 23px;
		letter-spacing: 0.005em;
		text-align: left;
	}
`;

const FilterOptions = styled.div`
	padding: 8px 16px;
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

const ModalFooter = styled.div`
	display: flex;
	justify-content: flex-end;
	padding: 12px 18px;
`;

interface FilterMySchedulesModalProps {
	isModalOpen: boolean;
	handleClose: () => void;
	handleApply: (value: IScheduleFilters) => void;
}

/**
 * ### Modal de filtros histórico de agendamentos
 */
const FilterMySchedulesModal = ({ isModalOpen, handleClose, handleApply }: FilterMySchedulesModalProps) => {
	const [searchParams] = useSearchParams();
	const { handleSubmit, setValue, watch } = useForm<IScheduleFilters>({
		defaultValues: {
			status: (searchParams.get("status") as StatusType) ?? undefined,
		},
	});

	useEffect(() => {
		setValue("status", (searchParams.get("status") as StatusType) ?? undefined);
	}, [searchParams]);

	const handleChangeStatus = (radioValue: boolean, fieldValue: StatusType) => {
		setValue("status", radioValue ? fieldValue : undefined);
	};

	const handleFormSubmit = handleSubmit(data => {
		handleClose();
		handleApply(data);
	});

	return (
		<ReactModal
			isOpen={isModalOpen}
			overlayClassName="modal-overlay-personalizado"
			contentElement={(props, children) => <ModalContainer onClick={e => e.stopPropagation()}>{children}</ModalContainer>}
			ariaHideApp={false}
			shouldCloseOnOverlayClick
		>
			<ModalHeader>Filtrar</ModalHeader>

			<ModalContent>
				<ModalFilterGroup>
					<span>Status</span>

					<FilterOptions>
						<RadioButtonField value={watch("status") === "PENDENTE"} onChange={value => handleChangeStatus(value, "PENDENTE")} label="Agendado" />
						<RadioButtonField value={watch("status") === "CANCELADO"} onChange={value => handleChangeStatus(value, "CANCELADO")} label="Cancelado" />
						<RadioButtonField
							value={watch("status") === "FINALIZADO"}
							onChange={value => handleChangeStatus(value, "FINALIZADO")}
							label="Realizado"
						/>
					</FilterOptions>
				</ModalFilterGroup>
			</ModalContent>

			<ModalFooter>
				<ButtonSecondary label="Aplicar" onClick={handleFormSubmit} />
			</ModalFooter>
		</ReactModal>
	);
};
export default FilterMySchedulesModal;
